import React, { useState, useRef, ChangeEvent } from 'react';
import { Form, Dropdown, InputGroup, Button } from 'react-bootstrap';

type InputType = 'Text' | 'File';
type FileInfo = {
    name: string;
    extension: string;
    pageCount: number;
};

const FileInputComponent: React.FC = () => {
    const [inputType, setInputType] = useState<InputType>('Text');
    const [text, setText] = useState('');
    const [wordCount, setWordCount] = useState(0);
    const [fileInfo, setFileInfo] = useState<FileInfo | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleInputTypeChange = (eventKey: string | null) => {
        if (eventKey) {
            setInputType(eventKey as InputType);
            setText('');
            setWordCount(0);
            setFileInfo(null);
        }
    };

    const handleTextChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newText = e.target.value;
        setText(newText);
        setWordCount(newText.trim().split(/\s+/).filter(Boolean).length);
    };

    const handleFileUpload = async (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const extension = file.name.split('.').pop() || '';
            // In a real-world scenario, you would need to implement proper file parsing
            // to get the actual page count. This is just a placeholder.
            const pageCount = await getPageCount(file);
            setFileInfo({
                name: file.name,
                extension,
                pageCount,
            });
        }
    };

    // Placeholder function for getting page count
    const getPageCount = async (file: File): Promise<number> => {
        // Implement actual page counting logic here
        return new Promise(resolve => setTimeout(() => resolve(Math.floor(Math.random() * 10) + 1), 1000));
    };

    return (
        <Form className="mt-3" >
            <Form.Group className="mb-3" >
                <Dropdown onSelect={handleInputTypeChange}>
                    <Dropdown.Toggle variant="primary" id="dropdown-input-type" >
                        {inputType}
                    </Dropdown.Toggle>
                    < Dropdown.Menu >
                        <Dropdown.Item eventKey="Text" > Text </Dropdown.Item>
                        < Dropdown.Item eventKey="File" > File </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Form.Group>

            {
                inputType === 'Text' ? (
                    <Form.Group className="mb-3" >
                        <Form.Label>Enter text: </Form.Label>
                        < Form.Control
                            type="text"
                            value={text}
                            onChange={handleTextChange}
                            placeholder="Type your text here"
                        />
                        <Form.Text>Word count: {wordCount} </Form.Text>
                    </Form.Group>
                ) : (
                    <Form.Group className="mb-3" >
                        <Form.Control
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                            accept=".pdf,.docx,.png,.jpg,.jpeg"
                            style={{ display: 'none' }}
                        />
                        < Button onClick={() => fileInputRef.current?.click()}>
                            Upload File
                        </Button>
                        {
                            fileInfo && (
                                <div className="mt-2" >
                                    <p>File name: {fileInfo.name} </p>
                                    < p > Extension: {fileInfo.extension} </p>
                                    < p > Page count: {fileInfo.pageCount} </p>
                                </div>
                            )
                        }
                    </Form.Group>
                )}
        </Form>
    );
};

export default FileInputComponent;